<template lang="pug">
.step-header
  h3.step-title {{__(title)}}
  p.step-description {{__(description)}}
</template>

<script setup lang="ts">
defineProps<{
  title: string,
  description: string,
}>()
</script>

<style lang="scss" scoped>
.step-title {
  font-size: $size-s;
  font-weight: bold;
  margin-bottom: $space-xs;
  text-transform: uppercase;
}

.step-description {
  font-size: $size-xs;
  margin-bottom: $space-s;
}
</style>
